import { useState } from 'react';

const faqs = [
  {
    q: '6080新视觉影院的影片需要付费吗？',
    a: '完全免费！6080新视觉影院所有电影、电视剧均提供免费在线观看服务，无需注册、无需付费、无需订阅会员。我们致力于让每一位影迷都能零门槛享受高清影视内容。',
  },
  {
    q: '为什么视频加载速度这么快？',
    a: '本站采用自主研发的智能多线加速引擎，结合全球CDN节点分发技术，能够根据您的网络环境自动选择最优线路，实现视频秒开不缓冲的流畅体验。',
  },
  {
    q: '支持哪些设备观看？需要安装播放器吗？',
    a: '无需安装任何播放器或插件。6080新视觉影院采用HTML5播放技术，完美兼容电脑、平板、手机等所有主流设备。打开浏览器即可观看，支持倍速播放、画质切换、记忆续播等功能。',
  },
  {
    q: '新上映的电影多久能上线？',
    a: '我们拥有专业的片源更新团队，热门院线影片通常在下映后1-3周内上线高清版本。热播电视剧一般在播出当天即可同步更新最新集数，确保你不错过任何精彩内容。',
  },
  {
    q: '画质可以达到什么水平？',
    a: '本站提供从标清到超清的多档画质选择，最高支持1080P全高清和4K超清画质。系统会根据您的网络状况智能推荐最佳画质，你也可以手动切换到自己偏好的清晰度。',
  },
  {
    q: '遇到影片无法播放怎么办？',
    a: '如果遇到播放问题，请先尝试切换画质或刷新页面。若问题持续存在，可以通过"联系我们"模块反馈具体影片名称，我们的技术团队会在第一时间排查修复。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            疑问解答
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            关于6080新视觉影院的使用，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-[760px] mx-auto flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 cursor-pointer text-left hover:bg-background-200/50 transition-colors"
              >
                <h3 className="text-sm font-semibold text-foreground-800 pr-2">
                  {faq.q}
                </h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-200 ${openIndex === idx ? 'rotate-180 bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}